import React, { useState } from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { Dropdown } from 'antd';
import { useTranslation } from 'react-i18next';

import PopoverFilter from '../filterPopover';
import Search from '../Search';
import FieldConfig from '../../../../../../../../common/FieldConfig';
import Icon from '../../../../../../../../common/UI/Icon';
import ButtonTransparent from '../../../../../../../../common/UI/ButtonTransparent';
import { VIEW_MODES, VIEW_MODES_CONFIG } from '../../../../../../../../../configs/viewSettings';

import styles from './viewSettings.less';

const ViewSettings = (props) => {
  const {
    scene,
    sceneId,
    catalogId,
    catalog,
    viewId,
    viewSettings,
    fields,
    allFields, // Все поля (для PropertiesComponent, если нужно)
    className,
    defaultVisible,
    hideControls,
    viewMode: rawViewMode,
    ...restProps
  } = props;

  const { t } = useTranslation();
  const [propertiesOpen, setPropertiesOpen] = useState(false);

  const viewMode = rawViewMode === 'records' ? 'table' : rawViewMode;
  const config = VIEW_MODES_CONFIG[viewMode];

  if (!config) return null;

  // Получаем компоненты из конфига
  const PropertiesComponent = config.properties;
  const ExtraComponent = config.extra;

  // Извлекаем настройки для конкретного режима
  const viewModeSettings = viewSettings && viewSettings.get(viewMode);

  return (
    <div className={cn(styles.container, className)}>
      <div className={styles.properties}>
        {/* ФИЛЬТРЫ - общий компонент для всех режимов */}
        {!hideControls && config.filters && (
          <div className={styles.property}>
            <PopoverFilter
              sceneId={sceneId}
              catalogId={catalogId}
              viewId={viewId}
              catalog={catalog}
              viewMode={viewMode}
            />
          </div>
        )}

        {/* FIELDS - общий компонент настройки полей */}
        {!hideControls && config.fields && (
          <div className={styles.property}>
            <FieldConfig
              catalogId={catalogId}
              sceneId={sceneId}
              fields={fields}
              viewMode={viewMode}
              viewSettings={viewSettings}
              sortable
              viewId={viewId}
              defaultVisible={config.fieldsDefaultVisible ?? defaultVisible}
            />
          </div>
        )}

        {/* PROPERTIES - специфичные настройки для каждого режима */}
        {!hideControls && PropertiesComponent && (
          <div className={styles.property}>
            <Dropdown
              dropdownRender={() => (
                <PropertiesComponent
                  catalog={catalog}
                  catalogId={catalogId}
                  sceneId={sceneId}
                  viewId={viewId}
                  viewSettings={viewModeSettings}
                  fields={allFields || fields}
                  viewMode={viewMode}
                  {...restProps}
                />
              )}
              trigger={['click']}
              placement="bottomRight"
              open={propertiesOpen}
              onOpenChange={setPropertiesOpen}
            >
              <ButtonTransparent>
                <Icon type="icon setting-13" />
                <span>{t('views.control')}</span>
              </ButtonTransparent>
            </Dropdown>
          </div>
        )}
      </div>
      {/* EXTRA - дополнительные компоненты */}
      {ExtraComponent && (
        <div className={styles.extra}>
          <ExtraComponent
            catalog={catalog}
            catalogId={catalogId}
            sceneId={sceneId}
            viewId={viewId}
            viewSettings={viewSettings}
            viewMode={viewMode}
            {...restProps}
          />
        </div>
      )}

      {config.search && (
        <Search scene={scene} sceneId={sceneId} viewId={viewId} viewMode={viewMode} className={styles.search} />
      )}
    </div>
  );
};

ViewSettings.propTypes = {
  sceneId: PropTypes.string.isRequired,
  catalogId: PropTypes.string.isRequired,
  catalog: PropTypes.object,
  viewId: PropTypes.string,
  viewSettings: PropTypes.object,
  viewMode: PropTypes.string.isRequired,
  fields: PropTypes.object,
  className: PropTypes.string,
  defaultVisible: PropTypes.bool,
};

export default ViewSettings;
